// import React, { useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import { encryptPayload, decryptResponse } from "./../CryptoUtil";
// import { api } from "./../../App";
// import indiaData from "./../../data/location_data.json";

// const EMPTY_FORM = {
//   zsm_id: "",
//   name: "",
//   email: "",
//   phone: "",
//   password: "",
//   address: "",
//   city: "",
//   state: "",
//   pincode: "",
// };

// const SEP = "|||";

// const normalize = (value) =>
//   String(value ?? "").trim().replace(/\s+/g, " ").toUpperCase();

// const parseStates = (value) => {
//   if (typeof value === "string") {
//     try {
//       value = JSON.parse(value);
//     } catch {
//       value = value.split(",");
//     }
//   }

//   if (!value || typeof value !== "object") return [];

//   if (!Array.isArray(value)) {
//     return Object.keys(value);
//   }

//   return value
//     .map((item) =>
//       typeof item === "string"
//         ? item
//         : item?.state || item?.name || ""
//     )
//     .filter(Boolean);
// };

// const decodeApiResponse = (raw) => {
//   if (raw?.encrypted?.payload !== undefined) {
//     return decryptResponse(
//       raw.encrypted.payload,
//       raw.encrypted.transactionId
//     );
//   }

//   return raw;
// };

// const getSession = () => {
//   try {
//     return JSON.parse(localStorage.getItem("userSession") || "null");
//   } catch {
//     return null;
//   }
// };

// const getDistricts = (state) => {
//   const data = indiaData?.[state];

//   if (Array.isArray(data)) {
//     return data
//       .map((item) =>
//         typeof item === "string"
//           ? item
//           : item?.name || item?.district || item?.city
//       )
//       .filter(Boolean);
//   }

//   if (data && typeof data === "object") {
//     return Object.keys(data);
//   }

//   return [];
// };

// const AddAsm = () => {
//   const [formData, setFormData] = useState(EMPTY_FORM);
//   const [zsms, setZsms] = useState([]);
//   const [selectedDistricts, setSelectedDistricts] = useState([]);
//   const [search, setSearch] = useState("");
//   const [loadingZsms, setLoadingZsms] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   const session = getSession();
//   const role = normalize(session?.user?.role);
//   const userCode = normalize(
//     session?.user?.code || session?.user?.user_code
//   );

//   const allStates = useMemo(
//     () => Object.keys(indiaData || {}).sort(),
//     []
//   );

//   const selectedZsm = useMemo(
//     () =>
//       zsms.find(
//         (zsm) => normalize(zsm.id) === normalize(formData.zsm_id)
//       ) || null,
//     [zsms, formData.zsm_id]
//   );

//   const allowedStates = useMemo(() => {
//     if (!selectedZsm) return [];

//     if (normalize(selectedZsm.id) === "ZSM1000") {
//       return allStates;
//     }

//     const raw =
//       selectedZsm.working_area_new ??
//       selectedZsm.working_area ??
//       selectedZsm.working_states ??
//       selectedZsm.working_state ??
//       [];

//     const names = parseStates(raw).map(normalize);

//     return allStates.filter((state) =>
//       names.includes(normalize(state))
//     );
//   }, [selectedZsm, allStates]);

//   const residentialDistricts = useMemo(
//     () => getDistricts(formData.state).sort(),
//     [formData.state]
//   );

//   const searchResults = useMemo(() => {
//     const query = normalize(search);

//     if (!query) return [];

//     const results = [];

//     for (const state of allowedStates) {
//       const stateMatch = normalize(state).includes(query);

//       for (const district of getDistricts(state)) {
//         if (stateMatch || normalize(district).includes(query)) {
//           results.push({
//             state,
//             district,
//             key: `${state}${SEP}${district}`,
//           });
//         }
//       }
//     }

//     return results.sort(
//       (a, b) =>
//         a.state.localeCompare(b.state) ||
//         a.district.localeCompare(b.district)
//     );
//   }, [search, allowedStates]);

//   const groupedResults = useMemo(() => {
//     const groups = {};

//     for (const item of searchResults) {
//       if (!groups[item.state]) groups[item.state] = [];
//       groups[item.state].push(item);
//     }

//     return groups;
//   }, [searchResults]);

//   const selectedObjects = useMemo(
//     () =>
//       selectedDistricts.map((key) => {
//         const [state, district] = key.split(SEP);
//         return { state, district, key };
//       }),
//     [selectedDistricts]
//   );

//   useEffect(() => {
//     let active = true;

//     const loadZsms = async () => {
//       try {
//         setLoadingZsms(true);

//         const currentSession = getSession();
//         const currentRole = normalize(currentSession?.user?.role);
//         const currentCode = normalize(
//           currentSession?.user?.code ||
//             currentSession?.user?.user_code
//         );

//         const response = await axios.get(`${api}getZsm.php`, {
//           withCredentials: true,
//           headers: {
//             Accept: "application/json",
//             ...(currentSession?.token
//               ? {
//                   Authorization: `Bearer ${currentSession.token}`,
//                 }
//               : {}),
//           },
//           timeout: 15000,
//         });

//         const result = decodeApiResponse(response.data);

//         const records = Array.isArray(result)
//           ? result
//           : Array.isArray(result?.data)
//           ? result.data
//           : Array.isArray(result?.zsms)
//           ? result.zsms
//           : [];

//         const filtered = records
//           .filter(
//             (zsm) => normalize(zsm.status || "active") === "ACTIVE"
//           )
//           .filter(
//             (zsm) =>
//               currentRole !== "ZSM" ||
//               normalize(zsm.id) === currentCode
//           );

//         if (!active) return;

//         setZsms(filtered);

//         if (currentRole === "ZSM") {
//           if (filtered.length === 1) {
//             setFormData((prev) => ({
//               ...prev,
//               zsm_id: String(filtered[0].id),
//             }));
//           } else if (!filtered.length) {
//             setError("No accessible active ZSM record found.");
//           }
//         } else if (!filtered.length) {
//           setError("No accessible active ZSM records found.");
//         }
//       } catch (err) {
//         if (!active) return;

//         console.error("GET ZSM ERROR:", err);

//         setError("Unable to load ZSM records. Check getZsm.php.");
//       } finally {
//         if (active) setLoadingZsms(false);
//       }
//     };

//     loadZsms();

//     return () => {
//       active = false;
//     };
//   }, []);

//   const handleInputChange = (event) => {
//     const { name, value } = event.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//       ...(name === "state" ? { city: "" } : {}),
//     }));

//     setError("");
//     setSuccess("");
//   };

//   const handleZsmChange = (event) => {
//     setFormData((prev) => ({
//       ...prev,
//       zsm_id: event.target.value,
//     }));

//     setSelectedDistricts([]);
//     setSearch("");
//     setError("");
//     setSuccess("");
//   };

//   const toggleDistrict = (state, district) => {
//     if (
//       !allowedStates.includes(state) ||
//       !getDistricts(state).includes(district)
//     ) {
//       setError("This district is not allowed.");
//       return;
//     }

//     const key = `${state}${SEP}${district}`;

//     setSelectedDistricts((prev) =>
//       prev.includes(key)
//         ? prev.filter((item) => item !== key)
//         : [...prev, key]
//     );

//     setError("");
//     setSuccess("");
//   };

//   const handleReset = () => {
//     setFormData({
//       ...EMPTY_FORM,
//       zsm_id: role === "ZSM" ? userCode : "",
//     });

//     setSelectedDistricts([]);
//     setSearch("");
//     setShowPassword(false);
//     setError("");
//     setSuccess("");
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     if (loading) return;

//     setError("");
//     setSuccess("");

//     const currentSession = getSession();
//     const currentRole = normalize(currentSession?.user?.role);
//     const currentCode = normalize(
//       currentSession?.user?.code ||
//         currentSession?.user?.user_code
//     );

//     if (
//       !currentSession?.token ||
//       !["ADMIN", "ZSM"].includes(currentRole) ||
//       !currentCode
//     ) {
//       setError("Login session invalid. Please login again.");
//       return;
//     }

//     const zsmId =
//       currentRole === "ZSM"
//         ? currentCode
//         : normalize(formData.zsm_id);

//     if (!selectedZsm || normalize(selectedZsm.id) !== zsmId) {
//       setError("Please select a valid reporting ZSM.");
//       return;
//     }

//     const name = formData.name.trim();
//     const email = formData.email.trim().toLowerCase();
//     const phone = formData.phone.trim();
//     const password = formData.password;

//     if (!name || name.length > 100) {
//       setError("Enter a valid ASM name.");
//       return;
//     }

//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
//       setError("Enter a valid email.");
//       return;
//     }

//     if (!/^\d{10,15}$/.test(phone)) {
//       setError("Phone must contain 10 to 15 digits.");
//       return;
//     }

//     if (password.length < 6) {
//       setError("Password must contain at least 6 characters.");
//       return;
//     }

//     if (formData.pincode && !/^\d{6}$/.test(formData.pincode.trim())) {
//       setError("Enter a valid 6-digit PIN code.");
//       return;
//     }

//     if (formData.state && !allStates.includes(formData.state)) {
//       setError("Invalid residential state.");
//       return;
//     }

//     if (
//       formData.city &&
//       !residentialDistricts.includes(formData.city)
//     ) {
//       setError("Invalid residential district.");
//       return;
//     }

//     const workingArea = {};

//     for (const key of selectedDistricts) {
//       const parts = key.split(SEP);

//       if (parts.length !== 2) {
//         setError("Invalid selected district.");
//         return;
//       }

//       const [state, district] = parts;

//       if (
//         !allowedStates.includes(state) ||
//         !getDistricts(state).includes(district)
//       ) {
//         setError("Selected district is outside ZSM coverage.");
//         return;
//       }

//       if (!workingArea[state]) {
//         workingArea[state] = [];
//       }

//       if (!workingArea[state].includes(district)) {
//         workingArea[state].push(district);
//       }
//     }

//     if (!Object.keys(workingArea).length) {
//       setError("Select at least one working district.");
//       return;
//     }

//     // Backend receives only one working-area field.
//     const payload = {
//       zsm_id: zsmId,
//       name,
//       email,
//       phone,
//       password,
//       address: formData.address.trim(),
//       city: formData.city,
//       state: formData.state,
//       pincode: formData.pincode.trim(),
//       working_area: workingArea,
//     };

//     setLoading(true);

//     try {
//       const response = await axios.post(
//         `${api}addAsm.php`,
//         encryptPayload(payload),
//         {
//           withCredentials: true,
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//             ...(currentSession?.token
//               ? {
//                   Authorization: `Bearer ${currentSession.token}`,
//                 }
//               : {}),
//           },
//           timeout: 20000,
//         }
//       );

//       const result = decodeApiResponse(response.data);

//       if (
//         result?.success !== true ||
//         result?.status !== "success"
//       ) {
//         throw new Error(result?.message || "Unable to add ASM.");
//       }

//       setFormData({
//         ...EMPTY_FORM,
//         zsm_id: currentRole === "ZSM" ? currentCode : "",
//       });

//       setSelectedDistricts([]);
//       setSearch("");
//       setShowPassword(false);

//       setSuccess(result.message || "ASM added successfully.");
//     } catch (err) {
//       console.error("ASM ADD ERROR:", {
//         message: err.message,
//         status: err.response?.status,
//         response: err.response?.data,
//         url: err.config?.url,
//       });

//       let message = err.message || "Unable to add ASM.";

//       if (err.response?.data) {
//         try {
//           const result = decodeApiResponse(err.response.data);
//           message = result?.message || message;
//         } catch {
//           message = "Unable to decode server response.";
//         }
//       } else if (err.code === "ECONNABORTED") {
//         message =
//           "Request timed out. Check if ASM was created before retrying.";
//       } else if (err.code === "ERR_NETWORK") {
//         message =
//           "Backend connection failed. Check PHP server, error log and CORS.";
//       }

//       setError(message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="row">
//       <div className="col-12 grid-margin stretch-card">
//         <div className="card">
//           <div className="card-body">
//             <h4 className="card-title">Add Area Sales Manager</h4>

//             <p className="card-description">
//               Select reporting ZSM, working districts and ASM account details.
//             </p>

//             {error && (
//               <div className="alert alert-danger" role="alert">
//                 {error}
//               </div>
//             )}

//             {success && (
//               <div className="alert alert-success" role="alert">
//                 {success}
//               </div>
//             )}

//             <form onSubmit={handleSubmit} autoComplete="off">
//               <h5>Reporting Manager</h5>

//               <div className="form-group">
//                 <label htmlFor="zsm_id">Select ZSM *</label>

//                 <select
//                   id="zsm_id"
//                   name="zsm_id"
//                   className="form-control"
//                   value={formData.zsm_id}
//                   onChange={handleZsmChange}
//                   disabled={
//                     loading || loadingZsms || role === "ZSM"
//                   }
//                   required
//                 >
//                   <option value="">
//                     {loadingZsms ? "Loading ZSMs..." : "Select ZSM"}
//                   </option>

//                   {zsms.map((zsm) => (
//                     <option key={zsm.id} value={zsm.id}>
//                       {zsm.id} - {zsm.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {selectedZsm && (
//                 <div className="alert alert-info">
//                   <strong>Reporting ZSM:</strong>{" "}
//                   {selectedZsm.id} - {selectedZsm.name}
//                   <div>
//                     <strong>Allowed states:</strong>{" "}
//                     {allowedStates.length}
//                   </div>
//                 </div>
//               )}

//               <hr />

//               <h5>Working Area</h5>

//               {!selectedZsm ? (
//                 <div className="alert alert-warning">
//                   Select ZSM first.
//                 </div>
//               ) : (
//                 <>
//                   <div className="mb-3">
//                     {allowedStates.map((state) => (
//                       <span
//                         key={state}
//                         className="badge badge-info mr-2 mb-2 p-2"
//                       >
//                         {state}
//                       </span>
//                     ))}
//                   </div>

//                   <div className="form-group">
//                     <label htmlFor="workingAreaSearch">
//                       Search State / District
//                     </label>

//                     <input
//                       id="workingAreaSearch"
//                       type="search"
//                       className="form-control"
//                       placeholder="Search Bhopal or Madhya Pradesh"
//                       value={search}
//                       onChange={(event) => setSearch(event.target.value)}
//                       disabled={loading}
//                     />
//                   </div>

//                   {search.trim() &&
//                     Object.entries(groupedResults).map(
//                       ([state, districts]) => (
//                         <div
//                           key={state}
//                           className="border rounded p-3 mb-3"
//                         >
//                           <h6>{state}</h6>

//                           <div className="row">
//                             {districts.map((item) => (
//                               <div
//                                 key={item.key}
//                                 className="col-md-4 mb-2"
//                               >
//                                 <label className="d-flex align-items-center">
//                                   <input
//                                     type="checkbox"
//                                     className="mr-2"
//                                     checked={selectedDistricts.includes(
//                                       item.key
//                                     )}
//                                     onChange={() =>
//                                       toggleDistrict(
//                                         item.state,
//                                         item.district
//                                       )
//                                     }
//                                     disabled={loading}
//                                   />
//                                   {item.district}
//                                 </label>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       )
//                     )}

//                   {search.trim() && searchResults.length === 0 && (
//                     <div className="alert alert-warning">
//                       No permitted matching district found.
//                     </div>
//                   )}
//                 </>
//               )}

//               <div className="mb-4">
//                 <div className="d-flex justify-content-between align-items-center">
//                   <strong>
//                     Selected Districts ({selectedObjects.length})
//                   </strong>

//                   <button
//                     type="button"
//                     className="btn btn-sm btn-outline-danger"
//                     onClick={() => setSelectedDistricts([])}
//                     disabled={loading}
//                   >
//                     Clear All
//                   </button>
//                 </div>

//                 <div className="mt-3">
//                   {selectedObjects.map((item) => (
//                     <span
//                       key={item.key}
//                       className="badge badge-primary p-2 mr-2 mb-2"
//                     >
//                       {item.district}, {item.state}

//                       <button
//                         type="button"
//                         className="btn btn-sm text-white ml-2 p-0"
//                         aria-label={`Remove ${item.district}`}
//                         onClick={() =>
//                           toggleDistrict(item.state, item.district)
//                         }
//                         disabled={loading}
//                       >
//                         ×
//                       </button>
//                     </span>
//                   ))}
//                 </div>
//               </div>

//               <hr />

//               <h5>ASM Account Details</h5>

//               <div className="row">
//                 {[
//                   ["name", "Full Name", "text"],
//                   ["email", "Email Address", "email"],
//                   ["phone", "Mobile Number", "tel"],
//                 ].map(([name, label, type]) => (
//                   <div className="col-md-6" key={name}>
//                     <div className="form-group">
//                       <label htmlFor={name}>{label} *</label>

//                       <input
//                         id={name}
//                         name={name}
//                         type={type}
//                         className="form-control"
//                         value={formData[name]}
//                         onChange={handleInputChange}
//                         disabled={loading}
//                         required
//                       />
//                     </div>
//                   </div>
//                 ))}

//                 <div className="col-md-6">
//                   <div className="form-group">
//                     <label htmlFor="password">Password *</label>

//                     <div className="input-group">
//                       <input
//                         id="password"
//                         name="password"
//                         type={showPassword ? "text" : "password"}
//                         className="form-control"
//                         value={formData.password}
//                         onChange={handleInputChange}
//                         minLength={6}
//                         disabled={loading}
//                         required
//                       />

//                       <div className="input-group-append">
//                         <button
//                           type="button"
//                           className="btn btn-outline-secondary"
//                           onClick={() =>
//                             setShowPassword((previous) => !previous)
//                           }
//                           disabled={loading}
//                         >
//                           {showPassword ? "Hide" : "Show"}
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <hr />

//               <h5>Residential Address</h5>

//               <div className="form-group">
//                 <label htmlFor="address">Address</label>

//                 <textarea
//                   id="address"
//                   name="address"
//                   className="form-control"
//                   rows={3}
//                   value={formData.address}
//                   onChange={handleInputChange}
//                   disabled={loading}
//                 />
//               </div>

//               <div className="row">
//                 <div className="col-md-6 form-group">
//                   <label htmlFor="state">State</label>

//                   <select
//                     id="state"
//                     name="state"
//                     className="form-control"
//                     value={formData.state}
//                     onChange={handleInputChange}
//                     disabled={loading}
//                   >
//                     <option value="">Select State</option>

//                     {allStates.map((state) => (
//                       <option key={state} value={state}>
//                         {state}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="col-md-6 form-group">
//                   <label htmlFor="city">District / City</label>

//                   <select
//                     id="city"
//                     name="city"
//                     className="form-control"
//                     value={formData.city}
//                     onChange={handleInputChange}
//                     disabled={loading || !formData.state}
//                   >
//                     <option value="">Select District</option>

//                     {residentialDistricts.map((city) => (
//                       <option key={city} value={city}>
//                         {city}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="col-md-6 form-group">
//                   <label htmlFor="pincode">PIN Code</label>

//                   <input
//                     id="pincode"
//                     name="pincode"
//                     type="text"
//                     inputMode="numeric"
//                     className="form-control"
//                     value={formData.pincode}
//                     onChange={handleInputChange}
//                     maxLength={6}
//                     disabled={loading}
//                   />
//                 </div>
//               </div>

//               <button
//                 type="submit"
//                 className="btn btn-primary mr-2"
//                 disabled={loading || loadingZsms}
//               >
//                 {loading ? "Saving ASM..." : "Add Area Sales Manager"}
//               </button>

//               <button
//                 type="button"
//                 className="btn btn-light"
//                 onClick={handleReset}
//                 disabled={loading}
//               >
//                 Reset Form
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddAsm;



import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { encryptPayload, decryptResponse } from "./../CryptoUtil";
import indiaData from "./../../data/location_data.json";

const API_BASE = "http://localhost/retailer_api/";

const EMPTY_FORM = {
  zsm_id: "",
  name: "",
  email: "",
  phone: "",
  password: "",
  address: "",
  state: "",
  city: "",
  pincode: "",
};

const normalize = (value) =>
  String(value ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .toUpperCase();

const getSession = () => {
  try {
    return JSON.parse(localStorage.getItem("userSession") || "{}");
  } catch {
    return {};
  }
};

const getHeaders = () => {
  const session = getSession();

  return {
    Accept: "application/json",
    ...(session?.token
      ? { Authorization: `Bearer ${session.token}` }
      : {}),
  };
};

const decodeResponse = (raw) => {
  if (raw?.encrypted?.payload !== undefined) {
    return decryptResponse(
      raw.encrypted.payload,
      raw.encrypted.transactionId
    );
  }

  if (raw?.payload !== undefined && raw?.transactionId) {
    return decryptResponse(raw.payload, raw.transactionId);
  }

  return raw;
};

const getErrorMessage = (error) => {
  try {
    const result = decodeResponse(error.response?.data);
    return result?.message || error.message || "Request failed.";
  } catch {
    return error.message || "Request failed.";
  }
};

const getDistricts = (state) => {
  const value = indiaData?.[state];

  if (Array.isArray(value)) {
    return value
      .map((item) =>
        typeof item === "string"
          ? item
          : item?.district || item?.name || item?.city || ""
      )
      .filter(Boolean);
  }

  if (value && typeof value === "object") {
    return Object.keys(value);
  }

  return [];
};

const parseCoverage = (raw) => {
  if (!raw) return {};

  let value = raw;

  if (typeof value === "string") {
    try {
      value = JSON.parse(value);
    } catch {
      return {};
    }
  }

  if (!value || typeof value !== "object") return {};

  const result = {};

  if (Array.isArray(value)) {
    value.forEach((item) => {
      if (typeof item === "string") {
        result[normalize(item)] = [];
      } else if (item && typeof item === "object") {
        const state = normalize(item.state || item.name);
        if (!state) return;

        const districts = item.districts || [];

        result[state] = Array.isArray(districts)
          ? districts
              .map((district) =>
                normalize(
                  typeof district === "string"
                    ? district
                    : district?.district || district?.name
                )
              )
              .filter(Boolean)
          : [];
      }
    });

    return result;
  }

  Object.entries(value).forEach(([state, districts]) => {
    const stateKey = normalize(state);

    if (Array.isArray(districts)) {
      result[stateKey] = districts
        .map((district) =>
          normalize(
            typeof district === "string"
              ? district
              : district?.district || district?.name
          )
        )
        .filter(Boolean);
    } else if (districts && typeof districts === "object") {
      result[stateKey] = Object.keys(districts).map(normalize);
    } else {
      result[stateKey] = [];
    }
  });

  return result;
};

const sameDistrict = (first, second) => {
  const a = normalize(first);
  const b = normalize(second);

  if (a === b) return true;

  return (
    (a === "HOSHANGABAD" && b === "NARMADAPURAM") ||
    (a === "NARMADAPURAM" && b === "HOSHANGABAD")
  );
};

const AddAsm = () => {
  const [formData, setFormData] = useState(EMPTY_FORM);

  const [zsms, setZsms] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState([]);

  const [districtSearch, setDistrictSearch] = useState("");
  const [zsmSearch, setZsmSearch] = useState("");

  const [loadingZsms, setLoadingZsms] = useState(true);
  const [saving, setSaving] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const session = getSession();
  const role = normalize(session?.user?.role);
  const userCode = normalize(
    session?.user?.code || session?.user?.user_code
  );

  const allStates = useMemo(
    () => Object.keys(indiaData || {}).sort(),
    []
  );

  const selectedZsm = useMemo(
    () =>
      zsms.find(
        (zsm) => normalize(zsm.id) === normalize(formData.zsm_id)
      ) || null,
    [zsms, formData.zsm_id]
  );

  const coverage = useMemo(() => {
    if (!selectedZsm) return {};

    if (normalize(selectedZsm.id) === "ZSM1000") {
      return Object.fromEntries(
        allStates.map((state) => [normalize(state), []])
      );
    }

    return parseCoverage(
      selectedZsm.working_area_new ??
        selectedZsm.working_area ??
        selectedZsm.working_states ??
        selectedZsm.working_state
    );
  }, [selectedZsm, allStates]);

  const allowedStates = useMemo(
    () =>
      allStates.filter((state) =>
        Object.prototype.hasOwnProperty.call(
          coverage,
          normalize(state)
        )
      ),
    [allStates, coverage]
  );

  const allowedDistricts = useMemo(() => {
    const result = [];

    allowedStates.forEach((state) => {
      const configured = coverage[normalize(state)] || [];

      getDistricts(state).forEach((district) => {
        if (
          configured.length === 0 ||
          configured.some((item) => sameDistrict(item, district))
        ) {
          result.push({
            state,
            district,
            key: `${state}|||${district}`,
          });
        }
      });
    });

    return result;
  }, [allowedStates, coverage]);

  const filteredDistricts = useMemo(() => {
    const query = normalize(districtSearch);

    if (!query) return [];

    return allowedDistricts.filter(
      (item) =>
        normalize(item.state).includes(query) ||
        normalize(item.district).includes(query)
    );
  }, [allowedDistricts, districtSearch]);

  const groupedDistricts = useMemo(() => {
    const groups = {};

    filteredDistricts.forEach((item) => {
      if (!groups[item.state]) groups[item.state] = [];
      groups[item.state].push(item);
    });

    return groups;
  }, [filteredDistricts]);

  const selectedObjects = useMemo(
    () =>
      selectedDistricts.map((key) => {
        const [state, district] = key.split("|||");
        return { state, district, key };
      }),
    [selectedDistricts]
  );

  const filteredZsms = useMemo(() => {
    const query = normalize(zsmSearch);

    if (!query) return zsms;

    return zsms.filter((zsm) =>
      normalize(`${zsm.id} ${zsm.name}`).includes(query)
    );
  }, [zsms, zsmSearch]);

  const residentialDistricts = useMemo(
    () => getDistricts(formData.state),
    [formData.state]
  );

  useEffect(() => {
    let active = true;

    async function loadZsms() {
      try {
        setLoadingZsms(true);

        const response = await axios.get(
          `${API_BASE}getZsm.php`,
          {
            withCredentials: true,
            headers: getHeaders(),
            timeout: 20000,
          }
        );

        const result = decodeResponse(response.data);

        if (result?.success === false) {
          throw new Error(result.message || "Unable to load ZSMs.");
        }

        const records = Array.isArray(result)
          ? result
          : Array.isArray(result?.zsms)
          ? result.zsms
          : Array.isArray(result?.data)
          ? result.data
          : [];

        let activeZsms = records.filter(
          (zsm) =>
            normalize(zsm.status || "active") === "ACTIVE"
        );

        const currentSession = getSession();
        const currentRole = normalize(
          currentSession?.user?.role
        );
        const currentCode = normalize(
          currentSession?.user?.code ||
            currentSession?.user?.user_code
        );

        if (currentRole === "ZSM") {
          activeZsms = activeZsms.filter(
            (zsm) => normalize(zsm.id) === currentCode
          );
        }

        if (currentRole === "ADMIN") {
          const hasDefault = activeZsms.some(
            (zsm) => normalize(zsm.id) === "ZSM1000"
          );

          if (!hasDefault) {
            activeZsms.unshift({
              id: "ZSM1000",
              name: "Default ZSM",
              status: "active",
            });
          }
        }

        if (!active) return;

        setZsms(activeZsms);

        if (currentRole === "ZSM" && activeZsms.length === 1) {
          setFormData((previous) => ({
            ...previous,
            zsm_id: activeZsms[0].id,
          }));
        }

        if (!activeZsms.length) {
          setError("No accessible active ZSM found.");
        }
      } catch (err) {
        if (active) {
          setError(getErrorMessage(err));
        }
      } finally {
        if (active) setLoadingZsms(false);
      }
    }

    loadZsms();

    return () => {
      active = false;
    };
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((previous) => ({
      ...previous,
      [name]: value,
      ...(name === "state" ? { city: "" } : {}),
    }));

    setError("");
    setSuccess("");
  };

  const handleZsmChange = (event) => {
    setFormData((previous) => ({
      ...previous,
      zsm_id: event.target.value,
    }));

    setSelectedDistricts([]);
    setDistrictSearch("");
    setError("");
    setSuccess("");
  };

  const toggleDistrict = (item) => {
    setSelectedDistricts((previous) =>
      previous.includes(item.key)
        ? previous.filter((key) => key !== item.key)
        : [...previous, item.key]
    );

    setError("");
    setSuccess("");
  };

  const handleReset = () => {
    setFormData({
      ...EMPTY_FORM,
      zsm_id: role === "ZSM" ? userCode : "",
    });

    setSelectedDistricts([]);
    setDistrictSearch("");
    setZsmSearch("");
    setShowPassword(false);
    setError("");
    setSuccess("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (saving) return;

    setError("");
    setSuccess("");

    const currentSession = getSession();
    const currentRole = normalize(currentSession?.user?.role);
    const currentCode = normalize(
      currentSession?.user?.code ||
        currentSession?.user?.user_code
    );

    if (!["ADMIN", "ZSM"].includes(currentRole)) {
      setError("Please login as Admin or ZSM.");
      return;
    }

    const zsmId =
      currentRole === "ZSM"
        ? currentCode
        : normalize(formData.zsm_id);

    if (
      !selectedZsm ||
      normalize(selectedZsm.id) !== zsmId
    ) {
      setError("Please select a valid reporting ZSM.");
      return;
    }

    if (!formData.name.trim()) {
      setError("Enter ASM name.");
      return;
    }

    if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
        formData.email.trim()
      )
    ) {
      setError("Enter a valid email address.");
      return;
    }

    if (!/^\d{10,15}$/.test(formData.phone.trim())) {
      setError("Enter a valid mobile number (10-15 digits).");
      return;
    }

    if (formData.password.length < 6) {
      setError("Password must contain at least 6 characters.");
      return;
    }

    if (
      formData.pincode &&
      !/^\d{6}$/.test(formData.pincode.trim())
    ) {
      setError("Enter a valid 6-digit PIN code.");
      return;
    }

    if (!selectedDistricts.length) {
      setError("Select at least one working district.");
      return;
    }

    const workingArea = {};

    selectedObjects.forEach(({ state, district }) => {
      if (!workingArea[state]) workingArea[state] = [];

      if (!workingArea[state].includes(district)) {
        workingArea[state].push(district);
      }
    });

    const payload = {
      zsm_id: zsmId,
      name: formData.name.trim(),
      email: formData.email.trim().toLowerCase(),
      phone: formData.phone.trim(),
      password: formData.password,
      address: formData.address.trim(),
      state: formData.state,
      city: formData.city,
      pincode: formData.pincode.trim(),
      working_area: workingArea,
    };

    setSaving(true);

    try {
      const response = await axios.post(
        `${API_BASE}addAsm.php`,
        encryptPayload(payload),
        {
          withCredentials: true,
          headers: {
            ...getHeaders(),
            "Content-Type": "application/json",
          },
          timeout: 20000,
        }
      );

      const result = decodeResponse(response.data);

      if (result?.success !== true) {
        throw new Error(
          result?.message || "Unable to add ASM."
        );
      }

      setSuccess(
        result.message || "ASM added successfully."
      );

      setFormData({
        ...EMPTY_FORM,
        zsm_id: currentRole === "ZSM" ? currentCode : "",
      });

      setSelectedDistricts([]);
      setDistrictSearch("");
      setShowPassword(false);
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="row">
      <div className="col-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">
              Add Area Sales Manager
            </h4>

            <p className="card-description">
              Select reporting ZSM, working districts
              and ASM account details.
            </p>

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            {success && (
              <div className="alert alert-success" role="alert">
                {success}
              </div>
            )}

            <form
              onSubmit={handleSubmit}
              autoComplete="off"
            >
              <h5 className="mb-3">
                Reporting Manager
              </h5>

              <div className="form-group">
                <label htmlFor="zsmSearch">
                  Search ZSM
                </label>

                <input
                  id="zsmSearch"
                  type="search"
                  className="form-control"
                  placeholder="Search ZSM ID or name"
                  value={zsmSearch}
                  onChange={(event) =>
                    setZsmSearch(event.target.value)
                  }
                  disabled={saving || loadingZsms}
                />
              </div>

              <div className="form-group">
                <label htmlFor="zsm_id">
                  Select Reporting ZSM *
                </label>

                <select
                  id="zsm_id"
                  name="zsm_id"
                  className="form-control"
                  value={formData.zsm_id}
                  onChange={handleZsmChange}
                  disabled={
                    saving ||
                    loadingZsms ||
                    role === "ZSM"
                  }
                  required
                >
                  <option value="">
                    {loadingZsms
                      ? "Loading ZSMs..."
                      : "Select ZSM"}
                  </option>

                  {filteredZsms.map((zsm) => (
                    <option
                      key={zsm.id}
                      value={zsm.id}
                    >
                      {zsm.id} - {zsm.name}
                    </option>
                  ))}
                </select>
              </div>

              {selectedZsm && (
                <div className="alert alert-info">
                  <strong>Reporting ZSM:</strong>{" "}
                  {selectedZsm.id} - {selectedZsm.name}

                  <div className="mt-2">
                    <strong>Allowed States:</strong>{" "}
                    {allowedStates.length}
                  </div>

                  <div>
                    <strong>
                      Available Working Districts:
                    </strong>{" "}
                    {allowedDistricts.length}
                  </div>
                </div>
              )}

              <hr />

              <h5 className="mb-3">
                Working Area Selection
              </h5>

              {!selectedZsm ? (
                <div className="alert alert-warning">
                  Please select a reporting ZSM first.
                </div>
              ) : (
                <>
                  <div className="mb-3">
                    {allowedStates.map((state) => (
                      <span
                        key={state}
                        className="badge badge-info mr-2 mb-2 p-2"
                      >
                        {state}
                      </span>
                    ))}
                  </div>

                  <div className="form-group">
                    <label htmlFor="districtSearch">
                      Search State / District
                    </label>

                    <input
                      id="districtSearch"
                      type="search"
                      className="form-control"
                      placeholder="Search Bhopal, Indore, Madhya Pradesh..."
                      value={districtSearch}
                      onChange={(event) =>
                        setDistrictSearch(
                          event.target.value
                        )
                      }
                      disabled={saving}
                    />
                  </div>

                  {districtSearch.trim() &&
                    Object.entries(
                      groupedDistricts
                    ).map(([state, districts]) => (
                      <div
                        key={state}
                        className="border rounded p-3 mb-3"
                      >
                        <h6 className="font-weight-bold mb-3">
                          {state}
                        </h6>

                        <div className="row">
                          {districts.map((item) => (
                            <div
                              key={item.key}
                              className="col-md-4 mb-2"
                            >
                              <label className="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  className="mr-2"
                                  checked={selectedDistricts.includes(
                                    item.key
                                  )}
                                  onChange={() =>
                                    toggleDistrict(item)
                                  }
                                  disabled={saving}
                                />

                                <span>
                                  {item.district}
                                </span>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}

                  {districtSearch.trim() &&
                    filteredDistricts.length === 0 && (
                      <div className="alert alert-warning">
                        No matching permitted district found.
                      </div>
                    )}
                </>
              )}

              <div className="border rounded p-3 mb-4">
                <div className="d-flex justify-content-between align-items-center">
                  <strong>
                    Selected Working Districts (
                    {selectedObjects.length})
                  </strong>

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={() =>
                      setSelectedDistricts([])
                    }
                    disabled={
                      saving ||
                      !selectedDistricts.length
                    }
                  >
                    Clear All
                  </button>
                </div>

                <div className="mt-3">
                  {!selectedObjects.length && (
                    <p className="text-muted mb-0">
                      No districts selected.
                    </p>
                  )}

                  {selectedObjects.map((item) => (
                    <span
                      key={item.key}
                      className="badge badge-primary p-2 mr-2 mb-2"
                    >
                      {item.district}, {item.state}

                      <button
                        type="button"
                        className="btn btn-sm text-white ml-2 p-0"
                        aria-label={`Remove ${item.district}`}
                        onClick={() =>
                          toggleDistrict(item)
                        }
                        disabled={saving}
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              </div>

              <hr />

              <h5 className="mb-3">
                ASM Account Details
              </h5>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="name">
                      Full Name *
                    </label>

                    <input
                      id="name"
                      name="name"
                      type="text"
                      className="form-control"
                      value={formData.name}
                      onChange={handleInputChange}
                      maxLength={100}
                      required
                      disabled={saving}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="email">
                      Email Address *
                    </label>

                    <input
                      id="email"
                      name="email"
                      type="email"
                      className="form-control"
                      value={formData.email}
                      onChange={handleInputChange}
                      maxLength={150}
                      required
                      disabled={saving}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="phone">
                      Mobile Number *
                    </label>

                    <input
                      id="phone"
                      name="phone"
                      type="tel"
                      className="form-control"
                      value={formData.phone}
                      onChange={handleInputChange}
                      maxLength={15}
                      required
                      disabled={saving}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="password">
                      Password *
                    </label>

                    <div className="input-group">
                      <input
                        id="password"
                        name="password"
                        type={
                          showPassword
                            ? "text"
                            : "password"
                        }
                        className="form-control"
                        value={formData.password}
                        onChange={handleInputChange}
                        minLength={6}
                        required
                        disabled={saving}
                      />

                      <div className="input-group-append">
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() =>
                            setShowPassword(
                              (previous) => !previous
                            )
                          }
                          disabled={saving}
                        >
                          {showPassword
                            ? "Hide"
                            : "Show"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <h5 className="mb-3">
                Residential Address
              </h5>

              <div className="form-group">
                <label htmlFor="address">
                  Address
                </label>

                <textarea
                  id="address"
                  name="address"
                  className="form-control"
                  rows={3}
                  value={formData.address}
                  onChange={handleInputChange}
                  disabled={saving}
                />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="state">
                      State
                    </label>

                    <select
                      id="state"
                      name="state"
                      className="form-control"
                      value={formData.state}
                      onChange={handleInputChange}
                      disabled={saving}
                    >
                      <option value="">
                        Select State
                      </option>

                      {allStates.map((state) => (
                        <option
                          key={state}
                          value={state}
                        >
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="city">
                      District / City
                    </label>

                    <select
                      id="city"
                      name="city"
                      className="form-control"
                      value={formData.city}
                      onChange={handleInputChange}
                      disabled={
                        saving || !formData.state
                      }
                    >
                      <option value="">
                        Select District
                      </option>

                      {residentialDistricts.map(
                        (district) => (
                          <option
                            key={district}
                            value={district}
                          >
                            {district}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="pincode">
                      PIN Code
                    </label>

                    <input
                      id="pincode"
                      name="pincode"
                      type="text"
                      inputMode="numeric"
                      className="form-control"
                      value={formData.pincode}
                      onChange={handleInputChange}
                      maxLength={6}
                      disabled={saving}
                    />
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <button
                  type="submit"
                  className="btn btn-primary mr-2"
                  disabled={
                    saving ||
                    loadingZsms ||
                    !selectedZsm
                  }
                >
                  {saving
                    ? "Saving ASM..."
                    : "Add Area Sales Manager"}
                </button>

                <button
                  type="button"
                  className="btn btn-light"
                  onClick={handleReset}
                  disabled={saving}
                >
                  Reset Form
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAsm;
